import { Stylist } from './../models/stylist/stylist.model';
import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})

export class ModalService {

  constructor( private readonly modalController: ModalController ) { }

  async presentModal(modalPage: string,opts:any) {
    const modal = await this.modalController.create({
      component: modalPage,
     // cssClass: 'my-custom-class',
      componentProps: opts
      
    });
    return await modal.present();
}


}